<template>
    <v-container class="pa-0">
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <Hero :show="showHero" />
                <Breadcrumbs :page="page" />
                <Heading :page="page" :template="template" />
                <v-row>
                    <v-col md="8">
                        <div
                            v-infinite-scroll="loadMore"
                            :infinite-scroll-disabled="busy"
                            infinite-scroll-distance="80"
                        >
                            <v-row dense>
                                <v-col
                                    v-for="item in list"
                                    :key="item.index"
                                    cols="6"
                                >
                                    <v-card>
                                        <v-card-title
                                            class="card-header"
                                            v-text="item.title[$i18n.locale]"
                                        ></v-card-title>
                                        <v-card-text>
                                            <div
                                                class="text--primary"
                                                v-text="
                                                    item.metaDesc
                                                        ? item.metaDesc[
                                                              $i18n.locale
                                                          ]
                                                        : ''
                                                "
                                            ></div>
                                            <p>
                                                {{ item.publishDate }}
                                            </p>
                                        </v-card-text>
                                        <v-card-actions>
                                            <!-- <v-btn
                                                width="100%"
                                                @click="
                                                    $router.push(
                                                        `/white-paper/${
                                                            item.slug[
                                                                $i18n.locale
                                                            ].current
                                                        }`
                                                    )
                                                "
                                            >
                                                Read Post
                                            </v-btn> -->
                                            <v-btn
                                                width="100%"
                                                :to="
                                                    link(
                                                        item.type,
                                                        item.slug,
                                                        $i18n.locale
                                                    )
                                                "
                                            >
                                                <TranslatableStringComponent :tstring="{string: 'readPost'}" />
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col md="4">
                        <!-- <SidebarBlog /> -->
                    </v-col>
                </v-row>

                <Footer :show="showFooter" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Breadcrumbs from '~/components/Breadcrumbs.vue'
// import SidebarBlog from '~/components/SidebarBlog.vue'
import Footer from '~/components/Footer.vue'
import Heading from '~/components/Heading.vue'
import Hero from '~/components/Hero.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 

import prependRoute from '~/util/prependRoute'

import { client } from '~/plugins/global.js'
export default {
    name: 'TemplateListing',
    components: {
        Breadcrumbs,
        Footer,
        Heading,
        Hero,
        TranslatableStringComponent,
        // SidebarBlog
    },
    props: {
        page: {
            type: Object,
            default: null
        },
        template: {
            type: String,
            default: 'Default'
        }
    },
    data() {
        return {
            showHero: false,
            showFooter: true,
            list: [],
            busy: false,
            isMoreAvailable: true
        }
    },
    computed: {},
    mounted() {
        this.populateListing(0, 8)
    },
    methods: {
        populateListing(first, last) {
            let groq
            if (this.$route.params.slug === 'white-papers') {
                groq = `*[_type in ["whitepaper"]]{'title':title,'publishDate':publishDate,'metaDesc':seometa.metaDescription,'type':_type,slug}| order(publishDate desc) [${first}...${last}]`
            } else {
                groq = `*[_type in ["article","whitepaper"]]{'title':title,'publishDate':publishDate,'metaDesc':seometa.metaDescription,'type':_type,slug}| order(publishDate desc) [${first}...${last}]`
            }

            client
                .fetch(groq.trim())
                .then((res) => {
                    if (res.length === 0) {
                        this.isMoreAvailable = false
                        this.busy = true
                    }
                    this.list = [...this.list, ...res]
                    // console.log(this.list)
                })
                .catch((err) => {
                    console.log('ERROR NAME:', err.name)
                    console.log('ERROR MESSAGE:', err.message)
                    console.log('ERROR STACK:', err.stack)
                })
        },
        loadMore() {
            if (this.list.length > 0 && this.isMoreAvailable) {
                this.populateListing(this.list.length, this.list.length + 8)
            }
        },
        link(type, slug, locale) {
            const calc = prependRoute({ type, slug })
            return calc[locale] || null
        }
    }
}
</script>
